export const MOVEMENTS_ROUTE_PATHS = {
  wallets: '/movements/wallets',
  debitCardTransactions: '/movements/debit-card-transactions',
  cashoutDeposits: '/movements/cashout-deposits',
  promo: '/movements/promo',
  withdrawals: '/movements/withdrawals',
  transfers: '/movements/tp/transfers',
  transfersBatch: '/movements/tp/transfers/batch',
  fullGateway: '/movements/full-gateway',
  fullGatewayMerchant: '/movements/full-gateway-merchant',
  platformTransfers: '/movements/platform-transfers',
  topUp: '/movements/top-up',
  pixTransfers: '/movements/pix-transfers',
};
